import Vue from 'vue'
import { getMenuList,getAdminMenuList,getAuthorityButtonKeys,getOrderByButtonKeys,getFinanceByButtonKeys } from '../../api/user'

// 懒加载 注意，动态加载路由需要
const loadView = (view) => {
  return (resolve) => view && view !== '/' && require([`@/views${view}`], resolve)
}


const state = {
  functionKey: [],
  routes: [],
  addRoutes: [],
  crmButtonAuth: [],
  orderButtonAuth:[],
  orderDetailAuth:null,
  financeButtonAuth:[],
  menuList: []
}

const mutations = {
  SET_FUNCTIONLIST: (state, functionKey) => {
    state.functionKey = functionKey
  },
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = routes
  },
  SET_CRMBUTTONAUTH: (state, buttonAuthList) => {
    state.crmButtonAuth = buttonAuthList
  },
  SET_ORDERBUTTONAUTH: (state, buttonAuthList) => {
    state.orderButtonAuth = buttonAuthList
  },
  // 订单详情页是否有选取
  SET_ORDER_DETAILAUTH:(state, orderAuth) => {
    state.orderDetailAuth = orderAuth
  },
  SET_FINANCEBUTTONAUTH: (state, buttonAuthList) => {
    state.financeButtonAuth = buttonAuthList
  },
  SET_CUSTOMERAUTH: (state, customerAuth) => {
    state.financeButtonAuth = customerAuth
  },
  // 保存原始菜单数据
  SET_ORIGIN_MENU_LIST: (state, list) => {
    state.menuList = list
  }
}

const actions = {
  // 获取大羽菜单
  getUserMenuList({ commit }) {
    return new Promise((resolve, reject) => {
      const model = {
        appId: '',
        enableAppFilter: ''
      }
      var routeList = []
      
      getMenuList(model).then(response => {
        const { data } = response
        const appId = Vue.prototype.$appId
        if (data !== null) {
          // 所有按钮权限
          commit('SET_FUNCTIONLIST', getFunctionKey(data.menuFunctionList))

          // 显示的菜单数据
          const list = Object.assign([], data.menuList)

          commit('SET_ORIGIN_MENU_LIST', filterAsyncMenu(list))

          // 前端动态路由
          // var routeList = filterAsyncRouter(data.menuList.filter(item => {
          //   if (item.urlProfix === appId) {
          //     return item
          //   }
          // }))
          routeList = filterAsyncRouter(data.menuList)
        }
        if(Number(appId) === 90002){
          // 个人设置
          routeList.push({
            path:'/90002/personal',
            name:'personal',
            meta:{
              title:'个人设置'
            },
            component : loadView('/personal'),
            hidden: true
          })
        }
        if(Number(appId) === 90010){
          // 个人设置
          routeList.push({
            path:'/90010/filedownload',
            name:'filedownload',
            meta:{
              title:'文件下载'
            },
            component : loadView('/filedownload'),
            hidden: true
          })
        }
        if(Number(appId) === 90020){
          routeList.push({
            path:'/90020/excel-preview',
            name:'doc-excel-preview',
            meta:{
              title:'导出预览',
              isScreen:true
            },
            component : loadView('/excel-preview'),
            hidden: true
          })
        }

        if (appId) {
          routeList.push({ path: '*', redirect: `/${appId}` })
          //routeList.push({ path: '*', redirect: '/404', hidden: true })
        }
        commit('SET_ROUTES', routeList)
        resolve(routeList)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取admin系统菜单
  // getUserAdminMenuList({commit}){
  //   return new Promise((resolve, reject) => {
  //     getAdminMenuList().then(response => {
  //       const { data } = response
  //       const appId = Vue.prototype.$appId
  //       if (data !== null) {
  //         // 所有按钮权限
  //         commit('SET_FUNCTIONLIST', getFunctionKey(data.menuFunctionList))

  //         // 显示的菜单数据
  //         const list = Object.assign([], data.menuList)

  //         commit('SET_ORIGIN_MENU_LIST', filterAsyncMenu(list))

  //         // 前端动态路由
  //         // var routeList = filterAsyncRouter(data.menuList.filter(item => {
  //         //   if (item.urlProfix === appId) {
  //         //     return item
  //         //   }
  //         // }))
  //         var routeList = filterAsyncRouter(data.menuList)
  //         if (appId) {
  //           routeList.push({ path: '*', redirect: `/${appId}` })
  //         }
  //       }
  //       commit('SET_ROUTES', routeList)
  //       resolve(routeList)
  //     }).catch(error => {
  //       reject(error)
  //     })
  //   })
  // },
  // 新的租户系统菜单
  getUserAdminMenuList({commit}){
    return new Promise((resolve, reject) => {
      const model = {
        appId: '',
        appIds : [3],
        enableAppFilter : true
      }
      getMenuList(model).then(response => {
        const { data } = response
        const appId = Vue.prototype.$appId

        if (data !== null) {
          // 所有按钮权限
          commit('SET_FUNCTIONLIST', getFunctionKey(data.menuFunctionList))

          // 显示的菜单数据
          const list = Object.assign([], data.menuList)

          commit('SET_ORIGIN_MENU_LIST', filterAsyncMenu(list))

          // 前端动态路由
          // var routeList = filterAsyncRouter(data.menuList.filter(item => {
          //   if (item.urlProfix === appId) {
          //     return item
          //   }
          // }))
          var routeList = filterAsyncRouter(data.menuList)
          if (appId) {
            routeList.push({ path: '*', redirect: `/${appId}` })
          }
        }
        commit('SET_ROUTES', routeList)
        resolve(routeList)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getCrmButtonAuthList({ commit }, data) {
    return new Promise((resolve, reject) => {
      getAuthorityButtonKeys(data).then(response => {
        const { data } = response
        let buttonAuth = []
        let customerAuth = 0
        if (data && data.buttonKeys && data.buttonKeys.length > 0) {
          buttonAuth = data.buttonKeys
        }
        if(data.customerAuth){
          customerAuth = data.customerAuth
        }
        commit('SET_CRMBUTTONAUTH', buttonAuth)
        commit('SET_CUSTOMERAUTH', customerAuth)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取订单按钮权限
  getOrderButtonAuthList({commit},data){
    return new Promise((resolve, reject) => {
      getOrderByButtonKeys(data).then(response => {
        const { data } = response
        let buttonAuth = []
        let orderAuth = 0
        if (data) {
          if(data.buttonKeys && data.buttonKeys.length > 0){
            buttonAuth = data.buttonKeys
          }
          if(data.orderAuth){
            orderAuth = data.orderAuth
          }
        }
        commit('SET_ORDERBUTTONAUTH', buttonAuth)
        commit('SET_ORDER_DETAILAUTH', orderAuth)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取财务按钮权限
  getFinanceButtonAuthList({commit},data){
    return new Promise((resolve, reject) => {
      getFinanceByButtonKeys(data).then(response => {
        const { data } = response
        let buttonAuth = []
        if (data && data.length > 0) {
          buttonAuth = data
        }
        commit('SET_FINANCEBUTTONAUTH', buttonAuth)
        resolve(buttonAuth)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

// 组装功能key
function getFunctionKey(data) {
  if (data && data.length > 0) {
    return data.map(item => item.functionKey)
  }
  return []
}

// 菜单递归处理关键字
function filterAsyncMenu(list) {
  if(!list || list.length === 0){
    return []
  }
  const func = (list, isLayout) => {
    return list.map(item => {
      const menuItem = {}
      setFactLink(menuItem, item, isLayout)

      const childNode = item.childNode || []

      return {
        ...item,
        ...menuItem,
        childNode: childNode.length ? func(item.childNode, false) : null
      }
    })
  }

  return func(list, true)
}

// 路由遍历
function filterAsyncRouter(menuList) {
  const routerList = []
  routerList.push({
    path: '/redirect',
    hidden: true,
    path: '/redirect/:path(.*)',
    component: () => import('../../redirect/index')
  })
  if (menuList === null || menuList.length ===0) {
    return routerList
  }
  // 遍历后台传来的路由字符串，转换为组件对象
    menuList.forEach(menu => {
      // 记录页面的路径包含当前
      menu.parentPath = '/'+menu.menuKey

      var router = routerConvert(menu, true)
      // 是否存在子节点，
      if (menu.childNode && menu.childNode.length) {
        var list = []
        getChildMenu(menu.childNode, list, router.parentPath)
        // 子节点判断是否存在当前应用
        list = list.filter(item => {
          if (item.urlProfix === Vue.prototype.$appId) {
            return item
          }
        })
        if (list.length > 0) {
          // router.children = []
          list.forEach(child => {
            child.parentPath = menu.parentPath + '/' +child.menuKey
            routerList.push(routerConvert(child, false))
            // router.children.push(routerConvert(child, false))
          })
        }
      }
      routerList.push(router)
    })  
  return routerList
}
// 路由转换
function routerConvert(menu, isLayout) {
  var router = {}
  router.name = menu.menuKey
  router.parentPath = menu.parentPath

  setFactLink(router, menu, isLayout)
  
  router.id = menu.id
  router.menuType = menu.menuType
  const rootPath = '/' + Vue.prototype.$appId
  if (isLayout) {
    // Layout组件特殊处理
    router.component = loadView(menu.link)
    router.path = rootPath
  } else {
    // var link = rootPath + (menu.link ? menu.link : '')
    // 处理组件---重点
    // 不带参数
    if (menu.link.indexOf(':') === -1) {
      router.component = loadView(menu.link)
    } else {
      // 带参数
      let link = menu.link.substring(0, menu.link.indexOf(':') - 1)
      router.component = loadView(link)
    }
    router.path = rootPath + (menu.link ? menu.link : '')
  }
  var meta = {}
  meta.title = menu.menuName
  meta.keepAlive = !!menu.isCache
  if (menu.iconCloass) {
    // 默认图标处理
    meta.icon = menu.iconCloass
  } else {
    meta.icon = 'user'
  }
  // 页面是否需要菜单和头部布局
  meta.isScreen = !!menu.isScreen
  meta.parentPath = menu.parentPath
  router.meta = meta
  // 是否是页面
  if (menu.menuType === 2) {
    router.hidden = true
  }
  return router
}

// 判断是当前应用的路由还是其他系统，其他系统转成https访问，当前系统使用路由访问
// 若是第三方外链，则不作任何处理
function setFactLink(router, menu, isLayout) {
  // 是否是外链（指本公司系统内的非当前应用）
  // 当前应用id
  const appId = Vue.prototype.$appId
  // 对象所属的应用id
  const urlProfix = menu.urlProfix

  // 如果应用id存在，则属于本公司系统，默认为第三方链接
  if (urlProfix) {
    if (Number(appId) === Number(urlProfix)) {
      if (isLayout) {
        // 因为接口数据如果是layout，返回的link为null，需要手动设置根路由
        router.link = '/' + Vue.prototype.$appId
      } else {
        // 当前应用，直接赋值
        router.link = '/' + Vue.prototype.$appId + menu.link
      }
    } else {
      if (isLayout) {
        router.link = 'https://'+window.location.hostname + '/' + urlProfix
      } else {
        router.link = 'https://'+window.location.hostname + '/' + urlProfix + menu.link
      }
    }
  } else {
    // 第三方链接，直接访问url
    router.link = menu.link
  }
}

// 递归获取子节点 parentPath=上级菜单的路径
function getChildMenu(childList, list,parentPath) {
  childList.forEach(item => {
    // 存储上级或本机菜单的路径
    if(parentPath){
      item.parentPath = parentPath + '/' + item.menuKey
    }
    if (item.link) {
      list.push(item)
    }
    if (item.childNode && item.childNode.length > 0) {
      getChildMenu(item.childNode, list, item.parentPath)
    }
  })
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
